module.exports = __webpack_public_path__ + "static/media/JuicedBikesLogo.025f76bc.avif";